$(".media_detail").click(function () {
  var tabID = $(this).attr("data-tab");
  $(this).addClass("active").siblings().removeClass("active");
  $("#tab-" + tabID)
    .addClass("active")
    .siblings()
    .removeClass("active");
});

$(".btn-contact").click(function () {
  $(".contact--form").slideToggle("slow");
});

var $temp = $("<input>");
var $url = $(location).attr("href");

$(".media-share-link").on("click", function () {
  $("body").append($temp);
  $temp.val($url).select();
  document.execCommand("copy");
  $temp.remove();
  $(".media-share-link span").text("copied!");
});

var headheight = $(".site-header-main").height();
var navheight = $(".site-navigation").height();
var totalnavheight = +headheight + +navheight + 30;

$("#nearby_properti").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".product-recommendations--container").offset().top - 150,
    },
    1000
  );
});
$("#property_detail").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".product-block--tabs").offset().top - 150,
    },
    1000
  );
});

$(".back_top").click(function () {
  $("html").animate({ scrollTop: 0 }, "slow");
});

$(document).ready(function () {
  setTimeout(function () {
    // $(".buy_now .shopify-payment-button__button .kqsiVA9Jf8LJAbxw8Bau span").text("Reserve Now");
  }, 1000);
});

$(".testimonial--password a").click(function () {
  var pass = $(".hidden-pass").attr("data-pass").toLowerCase();
  var indata = $(".testimonial--password input").val().toLowerCase();
  if (pass == indata) {
    $(".pass-wrapper").css("z-index", "0");
    $(".section-testimonials").css("z-index", "1");
  } else if (indata == "" || indata == null) {
    $(".valid--pass").text("Please enter the password");
    $(".valid--pass").css("visibility", "visible");
  } else {
    $(".valid--pass").text("please enter valid password");
    $(".valid--pass").css("visibility", "visible");
  }
});

// let genRnd = function() {
//     var min=5;
//     var max=20;
//     return Math.floor(Math.random() * (+max - +min)) + +min;
// };

// setInterval(
//     function() {
//         document.getElementById("cont").innerHTML = genRnd();
//     },4500);

// $(document).ready( function() {
//   // order delivery counter

//   var order_hour = localStorage.getItem('hours');
//   var order_min = localStorage.getItem('minutes');
//   console.log(order_hour,order_min);
//   $('.order_counter').html( order_hour + ' hours ' + order_min + ' minutes ');
// });

// setTimeout(function(){
// $('.buynow-btn.unabled').click(function(){
//    window.location.href='/checkout';
//   console.log('checkout');
// });
// }, 1000);

$(document).on("click", ".ad_to_cart", function () {
  var ID = $(this).find(".ad_to_cart_id").attr("var_id");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: 1,
      id: $(this).find(".ad_to_cart_id").attr("var_id"),
    },
    dataType: "json",
    success: function (data) {
      $("#CartCount span:first").text(data.quantity);
      console.log(data.quantity);
    },
  });
});

$("body").on("click", "#e-1679502754847 .product-wish img", function () {
  $(
    ".btns-wish-wrapper .swym-button-bar.swym-wishlist-button-bar button"
  ).trigger("click");
});

$(".onclickforsearch").click(function () {
  $(".site-header-mobile-search-button").click();
});

$(".mapiconview").click(function () {
  $("html,body").animate(
    {
      scrollTop: $(".productpropertymap").offset().top - 290,
    },
    "slow"
  );
});

$(".propertydetailsmain").click(function () {
  $("html,body").animate(
    {
      scrollTop: $(".custompropertydetailmain").offset().top - 240,
    },
    "slow"
  );
});

// set remaining time
var now = new Date();

var tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
var remainingTime = tomorrow - now;
var hours = Math.floor(remainingTime / (1000 * 60 * 60));
var minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
var seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

$(".timeleft").each(function () {
  var str = $(this).html();
  str = str.replace("$remtime", `${hours} hrs ${minutes} mins`);
  $(this).html(str);
});

console.log(
  `Time until next day: ${hours} hours, ${minutes} minutes, ${seconds} seconds`
);

// set remaining time

//set visitor count

$(".real-time-visitor").each(function () {
  var mincount = Number($(this).data("mincount"));
  var maxcount = Number($(this).data("maxcount"));
  var cont = randomIntFromInterval(mincount, maxcount);
  var str = $(this).html();
  str = str.replace("$realcount", cont);
  $(this).html(str);
});

function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

//set visitor count
if (
  $("body").data("template") == "ab-signed-property-page" ||
  $("body").data("template") == "coming-soon-properties"
) {
  $(".reservenow").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    // window.location = "tel:310-853-1455"
    $("html, body").animate(
      {
        scrollTop: $(".product-block--financial-option").offset().top - 380,
      },
      1000
    );
    // $(".product-block--financial-option").addClass('pulse-animate');
    //  setTimeout(function(){
    //   $(".product-block--financial-option").removeClass('pulse-animate');
    //   }, 2000);
  });

  $(".reservenowcompare")
    .unbind()
    .click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      //window.location = "tel:310-853-1455"
      $("html, body").animate(
        {
          scrollTop: $(".product-block--financial-option").offset().top - 380,
        },
        1000
      );
      //$(".product-block--financial-option").addClass('pulse-animate');
      // setTimeout(function(){
      //    $(".product-block--financial-option").removeClass('pulse-animate');
      //  }, 2000);
    });
} else if ($("body").data("template") == "ab-value-ladder") {
  if (document.body.offsetWidth < 990) {
    //     $(".buynow-btn-reserved-new").click(function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    //       $('html, body').animate({
    //           scrollTop: $(".financial-option-block-form").offset().top-200
    //       }, 1000);
    //     });
    $(".reservenow").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      $("html, body").animate(
        {
          scrollTop: $(".financial-option-block-form").offset().top - 200,
        },
        1000
      );
    });
  } else {
    //     $(".buynow-btn-reserved-new").click(function(e) {
    // e.preventDefault();
    // e.stopPropagation();
    //       $('html, body').animate({
    //           scrollTop: $(".financial-option-block-form").offset().top-400
    //       }, 1000);
    //     });
    $(".reservenow").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      $("html, body").animate(
        {
          scrollTop: $(".financial-option-block-form").offset().top - 400,
        },
        1000
      );
    });
  }
} else {
  $(".reservenow").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var url =
      "https://thelandspot.myshopify.com/cart/" +
      $(".variant-selection__variants").val() +
      ":1";
    openPopup(url);
  });

  $(".reservenowcompare")
    .unbind()
    .click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      var url =
        "https://thelandspot.myshopify.com/cart/" +
        $(this).data("compprid") +
        ":1";
      openPopup(url);
    });
}

function closePopup() {
  $(".term-popup").fadeOut(200);
}

function openPopup(url) {
  $(".term-popup").fadeIn(200);
  $(".acceptterms").click(function () {
    acceptTerms(url);
  });
}

$(".closepopup").click(function () {
  closePopup();
});

function acceptTerms(url) {
  closePopup();
  window.location.href = url;
}

jQuery.fn.shake = function (intShakes, intDistance, intDuration) {
  intShakes = intShakes || 10;
  intDistance = intDistance || 2;
  intDuration = intDuration || 1000;

  this.each(function () {
    $(this).css("position", "relative");
    for (var x = 1; x <= intShakes; x++) {
      $(this)
        .animate({ left: intDistance * -1 }, intDuration / intShakes / 4)
        .animate({ left: intDistance }, intDuration / intShakes / 2)
        .animate({ left: 0 }, intDuration / intShakes / 4);
    }
  });
  return this;
};
 
if ($("body").data("templatetype") == "product") {
  var settings = {
    url: "https://myfastlandsale.com/api/get_order_count.php",
    method: "GET",
    timeout: 0,
  };

  $.ajax(settings).done(function (response) {
    var count = response.count;
    $(".propertysold").each(function () {
      var str = $(this).html();
      str = str.replace("#soldcount", count);
      $(this).html(str);
      $(this).show();
    });
  }); 

  $(".range-slider input[type=range]").change(function () {
    var newval = $(this).val();
    var term = $(this).val();
    console.log(newval);
    $(".current-term").html(newval + " Months");

    $(".custom-finance-info-container .finance-plan").val(term);
    var selectedplan = $(".custom-finance-info-container .finance-plan").find(
      "option[data-sellterm='" + term + "'][data-variantterm='" + term + "']"
    );
    var cvarid = selectedplan.data("variantid");
    var csellid = selectedplan.data("planid");
    var price = selectedplan.data("planprice");

    $(".term-installment").html(Shopify.formatMoney(price, "${{amount}}"));
    $(".custom-finance-info-container .finance-plan").attr(
      "data-sellid",
      csellid
    );
    $(".custom-finance-info-container .finance-plan").attr(
      "data-varid",
      cvarid
    );
    var cpropvalue =
      selectedplan.data("variantprice") * term -
      (Number($(".range-slider input[type=range]").attr("data-totaltax")) /
        12) *
        term *
        100;
    $(".custom-finance-info-container .total-property-value").html(
      Shopify.formatMoney(cpropvalue, "${{amount_no_decimals}}")
    );
    var annualtax = Number($(this).attr("data-totaltax")) / 12;
    $(".custom-finance-info-container .monthly-tax").html(
      "$" + annualtax.toFixed(2)
    );
  });

  $(".checkout-finance").click(function () {
    var varid = $(".custom-finance-info-container .finance-plan").attr(
      "data-varid"
    );
    var sellid = $(".custom-finance-info-container .finance-plan").attr(
      "data-sellid"
    );
    // window.location.href = `https://thelandspot.myshopify.com/cart/clear?return_to=/cart/add?items[][id]=${varid}%26items[][quantity]=1%26items[][selling_plan]=${sellid}%26return_to=/checkout`;
    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      success: function () {
        var formParams = $("form.cart").serialize();
        $.ajax({
          url: "/cart/add.js",
          type: "post",
          data: {
            id: varid,
            selling_plan: sellid,
            properties: { _FinanceProperty: true },
            quantity: 1,
          },
          success: function () {
            console.log("test area error checkout");
            window.location = "/checkout";
          },
          error: function () {
            console.log("test area error");
          },
        });
      },
      dataType: "json",
    });
  });
}
window.addEventListener("pageshow", () => {
  initOnLoad();
});  

  

function initOnLoad() {
  $(".custom-finance-info-container .finance-plan")
    .find("option")
    .each(function () {
      var str = $(this).attr("data-sellterm");
      $(this).attr("data-sellterm", str.replace(/[^0-9.]/g, ""));
      var varterm = $(this).attr("data-variantterm");
      $(this).attr("data-variantterm", varterm.replace(/[^0-9.]/g, ""));
    });
  var term = $(".range-slider input[type=range]").attr("max");
  $(
    '.header-swatch-wrapper input[name="purchase"][data-valuename="finance"]'
  ).prop("checked", true);
  $(".range-slider input[type=range]").val(term);
  $(".custom-finance-info-container .finance-plan").val(term);
  var selectedplan = $(".custom-finance-info-container .finance-plan").find(
    "option[data-sellterm='" + term + "'][data-variantterm='" + term + "']"
  );
  var cvarid = selectedplan.data("variantid");
  var csellid = selectedplan.data("planid");

  $(".custom-finance-info-container .finance-plan").attr(
    "data-sellid",
    csellid
  );
  console.log(
    Number($(".range-slider input[type=range]").attr("data-totaltax"))
  );
  $(".custom-finance-info-container .finance-plan").attr("data-varid", cvarid);
  var cpropvalue =
    selectedplan.data("variantprice") * term -
    (Number($(".range-slider input[type=range]").attr("data-totaltax")) / 12) *
      term *
      100;
  $(".custom-finance-info-container .total-property-value").html(
    Shopify.formatMoney(cpropvalue, "${{amount_no_decimals}}")
  );
  var price = selectedplan.data("planprice");

  $(".term-installment").html(Shopify.formatMoney(price, "${{amount}}"));
  var annualtax =
    Number($(".range-slider input[type=range]").attr("data-totaltax")) / 12;
  $(".custom-finance-info-container .monthly-tax").html(
    "$" + annualtax.toFixed(2)
  );
  $(".checkout-finance").css("pointer-events", "auto");
}

$(document).on("click", ".scroll-btn", function (e) {
  e.preventDefault(); // Prevent the default anchor behavior
  var targetSection = $(this).attr("href"); // Get the href value (target section ID)
  // Calculate the total height of the announcement bar and header
  var announcementBarHeight =
    $("#shopify-section-new-announcement-bar").outerHeight() || 0;
  var headerHeight = $(".site-header").outerHeight() || 0;
  var totalHeight = announcementBarHeight + headerHeight;

  // Scroll to the target section with an offset of 210px
  $("html, body").animate(
    {
      scrollTop: $(targetSection).offset().top - totalHeight,
    },
    500
  ); // 500ms animation time (adjust as needed)
});
console.log(URL)